var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseDoorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 80,
    viewBox: "0 0 90 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.2925 37.149H33.8593V25.9414C33.8679 20.6704 38.1287 16.4082 43.3967 16.4067H46.7555C52.0213 16.4082 56.2869 20.6704 56.2925 25.9414V37.149ZM49.373 72.849H40.7751L41.9004 61.668C40.4364 60.6514 39.4749 58.9658 39.4749 57.0533C39.4749 53.9562 41.9777 51.4467 45.0752 51.4467C48.1723 51.4467 50.6874 53.9562 50.6874 57.0533C50.6874 58.9658 49.7192 60.6514 48.2604 61.668L49.373 72.849ZM65.8982 37.149H61.8939V25.9414C61.8939 17.5729 55.1222 10.8 46.7555 10.8H43.3967C35.0293 10.8 28.2594 17.5729 28.2594 25.9414V37.149H24.2571C19.8039 37.149 16.2002 40.569 16.2002 44.7979V71.5564C16.2002 75.7785 19.8039 79.2 24.2571 79.2H65.8982C70.3423 79.2 73.9607 75.7785 73.9607 71.5564V44.7979C73.9607 40.569 70.3423 37.149 65.8982 37.149Z",
    fill: "#001236"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDoorIcon);
export default __webpack_public_path__ + "static/media/closeDoorIcon.5b747d22491c05a997cb63cdbb177729.svg";
export { ForwardRef as ReactComponent };